// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button-wide {\n    min-width: 15em;\n}\n\n.state-dialog-hours-list {\n    margin-bottom: 0.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
